import { useTranslation } from 'react-i18next';
import { S } from '../../regureStyles';
import Card from './Card';

const AccessLog = ({ request }) => {
  const { t } = useTranslation();
  return (
    <Card title={t('screens.esign.cardAuditTrail')}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 0, border: `1px solid ${S.borderLight}`, borderRadius: 12, overflow: 'hidden' }}>
        {request.accessLog.map((entry, i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 12,
              padding: '12px 16px',
              borderBottom: i < request.accessLog.length - 1 ? `1px solid ${S.borderLight}` : 'none',
              background: i % 2 === 0 ? '#fff' : S.bgCard,
            }}
          >
            <div style={{ width: 7, height: 7, borderRadius: '50%', background: S.burgundy, flexShrink: 0, marginTop: 5 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, color: S.textPrimary }}>
                <strong style={{ textTransform: 'capitalize' }}>{entry.action}</strong>
                {entry.actorName && ` — ${entry.actorName}`}
                {entry.actor && entry.actorName !== entry.actor && ` (${entry.actor})`}
              </div>
              {entry.details && <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{entry.details}</div>}
            </div>
            <div style={{ fontSize: 11, color: S.textMuted, whiteSpace: 'nowrap' }}>
              {entry.timestamp ? new Date(entry.timestamp).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default AccessLog;
